// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"af91e716","842":"0be4b0e5"}[chunkId] + ".chunk.css";
};